import { createAsyncAction } from "typesafe-actions";
import { IBroadcast, IProfile } from "../api/APIClient";
import {
  AdminCallsListReply,
  AdminCallsListRequest,
  AdminCallUpdateReply,
} from "dialup";

export const createBroadcast = createAsyncAction(
  "CREATE_BROADCAST_REQUEST",
  "CREATE_BROADCAST_SUCCESS",
  "CREATE_BROADCAST_FAILURE"
)<void, IBroadcast, Error>();

export const listCallsProgress = createAsyncAction(
  "LIST_CALLS_REQUEST",
  "LIST_CALLS_SUCCESS",
  "LIST_CALLS_FAILURE"
)<void, AdminCallsListReply, Error>();

export const updateCallProgress = createAsyncAction(
  "UPDATE_CALL_REQUEST",
  "UPDATE_CALL_SUCCESS",
  "UPDATE_CALL_FAILURE"
)<void, AdminCallUpdateReply, Error>();

export const listMoreCallsProgress = createAsyncAction(
  "LIST_MORE_CALLS_REQUEST",
  "LIST_MORE_CALLS_SUCCESS",
  "LIST_MORE_CALLS_FAILURE"
)<
  void,
  {
    request: AdminCallsListRequest;
    reply: AdminCallsListReply;
  },
  Error
>();

export const getBroadcastAudience = createAsyncAction(
  "GET_BROADCAST_AUDIENCE_REQUEST",
  "GET_BROADCAST_AUDIENCE_SUCCESS",
  "GET_BROADCAST_AUDIENCE_FAILURE"
)<void, IProfile[], Error>();



// WEBPACK FOOTER //
// ./src/actions/broadcastActions.ts